import React, { useEffect, useRef } from "react";
import { AiFillHeart } from "react-icons/ai";

function getRandomScale() {
  return Math.random() * (1.6 - 0.6) + 0.6;
}

function getRandomColor() {
  const colors = ["#FF64B5", "#FF99C7", "#FFBBE0"];
  return colors[Math.floor(Math.random() * colors.length)];
}

export default function QuizHeart({ delay, className = "" }) {
  const ref = useRef();

  const color = getRandomColor();
  const scale = getRandomScale();

  const posX = Math.random() * 100;
  const posY = Math.random() * 100;

  useEffect(() => {
    setTimeout(() => {
      if (ref.current) {
        ref.current.style.transform = `
      scale(${scale})
    `;
      }
    }, delay);
  }, [delay]);

  return (
    <div
      ref={ref}
      className={`absolute transition-all duration-500 ${className}`}
      style={{
        top: `calc(${posY}vh - 15px)`,
        left: `calc(${posX}vw - 15px)`,
        transform: `scale(0)`,
      }}
    >
      <AiFillHeart size={50} color={color} />
    </div>
  );
}
